import { StatusIndicator } from '@strata/react-status-indicators';

// Cookie key value
export const ENVIRONMENT_COOKIE_KEY = 'ENVIRONMENT';

// Session storage key value
export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT';

// Local storage key value
export const TOKEN_FETCHED_AT = 'TOKEN_FETCHED_AT';

/** Friendly ID of all invalid referrals */
export const INVALID_REFERRAL_FRIENDLY_ID = 'INVALID-REFERRAL';

export const UNSPECIFIED_NPI = '8999999999';

export const OnboardingStatus = {
    RX_NEEDED: 'RX_NEEDED',
    RX_AT_PHARM: 'RX_AT_PHARM',
    ADJ_ISSUE: 'ADJ_ISSUE',
    PA_ISSUE: 'PA_ISSUE',
    CLAIM_PAYABLE: 'CLAIM_PAYABLE',
    PAID_CLAIM: 'PAID_CLAIM',
    MEMBER_OUTREACH: 'MEMBER_OUTREACH',
    PEND_SHIPMENT: 'PEND_SHIPMENT',
    SHIPPED: 'SHIPPED',
    FILLED: 'FILLED',
    ON_THERAPY: 'ON_THERAPY',
    ON_HOLD: 'ON_HOLD',
    PEND_CANCELED: 'PEND_CANCELED',
};

export const OnboardingStatusIndicatorMap = {
    [OnboardingStatus.RX_NEEDED]: {
        message: 'Rx Needed',
        tooltip:
            'Rx acquisition delayed due to prescriber response, transfer attempts, or escalation',
        status: StatusIndicator.Status.WARNING,
    },
    [OnboardingStatus.RX_AT_PHARM]: {
        message: 'Rx at Pharmacy',
        tooltip:
            'Rx is in hand, or in hand with pending eligibility, plan or provider information verification',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.ADJ_ISSUE]: {
        message: 'Adjudication Issue',
        tooltip:
            'Claim processing is impacted by plan limitations, utilization rules, or lock issues',
        status: StatusIndicator.Status.WARNING,
    },
    [OnboardingStatus.PA_ISSUE]: {
        message: 'PA Issue',
        tooltip:
            'Referral is delayed due to prior authorization requirements, formulary restrictions, or appeal processes',
        status: StatusIndicator.Status.WARNING,
    },
    [OnboardingStatus.CLAIM_PAYABLE]: {
        message: 'Test Claim',
        tooltip: 'Test claim has been validated',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.PAID_CLAIM]: {
        message: 'Paid Claim',
        tooltip: 'Paid claim has been confirmed',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.MEMBER_OUTREACH]: {
        message: 'Member Outreach',
        tooltip: 'Pharmacy or plan are attempting to contact member for additional information',
        status: StatusIndicator.Status.WARNING,
    },
    [OnboardingStatus.PEND_SHIPMENT]: {
        message: 'Pending Shipment',
        tooltip:
            'Product is prepared and ready, but final delivery is awaiting scheduling or coordination',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.SHIPPED]: {
        message: 'Shipped',
        tooltip: 'Tracking information received for shipment',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.FILLED]: {
        message: 'Filled',
        tooltip: 'First fill has been successfully dispensed',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.ON_THERAPY]: {
        message: 'On Therapy',
        tooltip: 'First fill confirmed',
        status: StatusIndicator.Status.SUCCESS,
    },
    [OnboardingStatus.PEND_CANCELED]: {
        message: 'Pend. Canceled',
        tooltip: 'Referral to be cancelled due to clinical, logistical, or administrative factors',
        status: StatusIndicator.Status.DEFAULT,
    },
    [OnboardingStatus.ON_HOLD]: {
        message: 'On Hold',
        tooltip: 'Referral on hold due to timing, prescriber, pharmacy, or member-initiated delays',
        status: StatusIndicator.Status.DEFAULT,
    },
};

export const TreatmentMergeCaseStatus = {
    PENDING: 'PENDING',
    MERGED: 'MERGED',
    DISMISSED: 'DISMISSED',
    UNMERGED: 'UNMERGED',
    SPLIT_REQUIRED: 'SPLIT_REQUIRED',
};

export const TreatmentMergeCaseStatusIndicatorMap = {
    [TreatmentMergeCaseStatus.PENDING]: {
        message: 'Pending',
        status: StatusIndicator.Status.IN_PROGRESS,
    },
    [TreatmentMergeCaseStatus.MERGED]: {
        message: 'Merged',
        status: StatusIndicator.Status.SUCCESS,
    },
    [TreatmentMergeCaseStatus.DISMISSED]: {
        message: 'Dismissed',
        status: StatusIndicator.Status.DEFAULT,
    },
    [TreatmentMergeCaseStatus.UNMERGED]: {
        message: 'Unmerged',
        status: StatusIndicator.Status.DEFAULT,
    },
    [TreatmentMergeCaseStatus.SPLIT_REQUIRED]: {
        message: 'Split Required',
        status: StatusIndicator.Status.CAUTION,
    },
};

export const PharmacyIntegrationSendOnOption = {
    SVC_START: 'SVC_START',
    OUTREACH: 'OUTREACH',
};

export const UpdateAddressReasons = [
    'Address update, no interruption of service',
    'State change - permanent',
    'State change - routine/temporary travel',
];

export const UpdatePhoneReasons = [
    'Patient phone number not listed on referral',
    'Alternate patient phone number obtained',
];

export const ReferralExpirationStrategy = {
    DEFAULT: 'DEFAULT',
    LATEST_AUTH_EXP_DATE: 'LATEST_AUTH_EXP_DATE',
    ON_DATE: 'ON_DATE',
    STAGGERED: 'STAGGERED',
};

export const ReferralExpirationStrategyTextMap = {
    [ReferralExpirationStrategy.DEFAULT]: 'Default',
    [ReferralExpirationStrategy.LATEST_AUTH_EXP_DATE]: 'Latest auth expiration date',
    [ReferralExpirationStrategy.ON_DATE]: 'On specific date',
    [ReferralExpirationStrategy.STAGGERED]: 'Staggered weekdays',
};

export const ReferralExpirationStrategyOptions = Object.values(ReferralExpirationStrategy).map(
    (strategy) => ({
        value: strategy,
        name: ReferralExpirationStrategyTextMap[strategy],
    }),
);
